module.exports = __webpack_public_path__ + "static/media/remixicon.5ab3a2a4.woff2";